module.exports = __webpack_public_path__ + "img/2010_S.8c38cffe.png";